import { fillArr, randomNum } from '@hglobal/common';
import { ShopOrder, DeliveryMethod } from '@pt/models';

import { getDetailLocationMock } from './locations.mocks';
import { getOrderProductsMock } from './product.mocks';

export function getShopOrderMock(id?: number, locationId?: number): ShopOrder {
  return {
    id,
    location: getDetailLocationMock(locationId || 1),
    deliveryMethods: getDeliveryMethodsMock(randomNum(9, 1)),
    products: id ? getOrderProductsMock(id) : [],
    delivery: null,
    total: 0,
  };
}

export function getShopOrdersMock(count = 3): ShopOrder[] {
  return fillArr(count, i => getShopOrderMock(i, i));
}

export function getDeliveryMethodsMock(count = 9): DeliveryMethod[] {
  return [
    {
      id: 'international',
      name: 'International',
    },
    {
      id: 'ukrposhta',
      name: 'Ukrposhta',
    },
    {
      id: 'nova_poshta',
      name: 'Nova Poshta',
    },
    {
      id: 'fedex',
      name: 'Fedex',
    },
    {
      id: 'dhl',
      name: 'DHL',
    },
    {
      id: 'dpd',
      name: 'DPD',
    },
    {
      id: 'inpost',
      name: 'inPost',
    },
    {
      id: 'acs',
      name: 'ACS',
    },
    {
      id: 'gap_akis_express',
      name: 'GAP Akis Express',
    },
  ].slice(0, count - 1 < 8 ? count - 1 : 8);
}
